import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { I18n } from "react-i18next";
import "../utils/i18n";

const DetailRow = props => (
  <div className="row">
    <div className="span2 text-right detail-space-top-element">
      {props.title}
    </div>
    <div className="span6 formfeld">{props.value}</div>
  </div>
);

class DetailData extends Component {
  render() {
    return (
      <I18n>
        {(t, { i18n }) => (
          <div>
            <div className="row">
              <div className="span8 detail-space-top-title">
                <strong>{t("detail.Personen")}</strong>
              </div>
            </div>
            <DetailRow
              title={t("detail.OrgelbauerExperte")}
              value={this.props.detail.orgelbauer.personen_orgelbauer}
            />
            <DetailRow
              title={t("detail.Massnahme")}
              value={this.props.detail.orgelbauer.personen_massnahme}
            />
            <DetailRow
              title={t("detail.Datum")}
              value={this.props.detail.orgelbauer.personen_datum}
            />
            <div className="row">
              <div className="span8 detail-space-top-title">
                <strong>{t("detail.Orgel")}</strong>
              </div>
            </div>
            <DetailRow
              title={t("detail.AnzahlManuale")}
              value={this.props.detail.orgel.anzmanuale}
            />
            <DetailRow
              title={t("detail.Manualumfang")}
              value={this.props.detail.orgel.umfangmanuale}
            />
            <DetailRow
              title={t("detail.Pedalumfang")}
              value={this.props.detail.orgel.umfangpedale}
            />
            <DetailRow
              title={t("detail.Spieltraktur")}
              value={this.props.detail.orgel.spieltraktur}
            />
            <DetailRow
              title={t("detail.Registertraktur")}
              value={this.props.detail.orgel.registertraktur}
            />
            <DetailRow
              title={t("detail.Spielhilfen")}
              value={
                this.props.detail.orgel.spielhilfen.length > 0 && (
                  <div>
                    {this.props.detail.orgel.spielhilfen.map((item, i) => (
                      <div key={i}>{item}</div>
                    ))}
                  </div>
                )
              }
            />
            <DetailRow
              title={t("detail.Stimmtonhoehe")}
              value={this.props.detail.orgel.stimmtonhoehe}
            />
            <div className="row">
              <div className="span2 text-right detail-space-top-element">
                {t("detail.Stimmung")}
              </div>
              <div className="span6 formfeld">
                {this.props.detail.orgel.stimmung}
              </div>
            </div>
            <DetailRow
              title={t("detail.Balganlage")}
              value={this.props.detail.orgel.balganlage}
            />
            <DetailRow
              title={t("detail.WinddruckInMm")}
              value={this.props.detail.orgel.winddruck}
            />
            <DetailRow
              title={t("detail.Bemerkungen")}
              value={this.props.detail.orgel.kommentar}
            />
            <div className="row">
              <div className="span8 detail-space-top-title">
                <strong>{t("detail.Disposition")}</strong>
              </div>
            </div>
            {this.props.detail.disposition.dispositionen.map(
              ({ werk, tonhoehe }) => (
                <div className="row" key={werk}>
                  <div className="span2 text-right detail-space-top-element">
                    {werk}
                  </div>
                  <div className="span6 formfeld">
                    {tonhoehe.map(({ register, kommentar }) => (
                      <div key={register}>
                        {register}
                        <span className="register-kommentar">{kommentar}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )
            )}
            {this.props.detail.disposition.textdisposition && (
              <DetailRow
                title=""
                value={this.props.detail.disposition.textdisposition}
              />
            )}
            <div className="row">
              <div className="span8 detail-space-top-title">
                <strong>{t("detail.QuellenUndBibliographie")}</strong>
              </div>
            </div>
            {this.props.bibliographie.map((item, i) => (
              <div className="row" key={i}>
                <div className="span2 text-right detail-space-top-element">
                  &nbsp;
                </div>
                <div className="span6 formfeld">
                  {item.map((entry, k) => <div key={k}>{entry}</div>)}
                </div>
              </div>
            ))}
            <div className="row">
              <div className="span8 detail-space-top-title">
                <strong>{t("detail.Orgelgeschichte")}</strong>
              </div>
            </div>
            {this.props.orgelgeschichte.map(({ datum, aktion, person, id }) => (
              <div className="row" key={id}>
                <div className="span2 text-right detail-space-top-element">
                  {datum}
                </div>
                <div className="span5 formfeld">
                  {aktion}
                  <br />
                  {person.join(", ")}
                </div>
                <div className="span1 hslu-link detail-space-top-element">
                  <Link to={`/detail/${id}`}>
                    {t("navigation.Details")} &raquo;
                  </Link>
                </div>
              </div>
            ))}
            <div className="row">
              <div className="span8 detail-space-top-title">
                {t("detail.LetzteAktualisierung")}{" "}
                {this.props.detail.letzteAenderung}
              </div>
            </div>
            <div className="row">
              <div className="span8 detail-space-top-title">&nbsp;</div>
            </div>
          </div>
        )}
      </I18n>
    );
  }
}

export default withRouter(DetailData);



// WEBPACK FOOTER //
// ./src/detail/DetailData.js